import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
// import locale from 'element-ui/lib/locale/lang/en'
import App from './App'
import router from './router'
import store from './store' //vuex数据
import '@/icons' // icon
import '@/permission' // 权限
import common from './common_js/common' //公共JS函数文件
import directive from './directive/index';
import filters from '@/utils/filters'
import vueXlsxTable from 'vue-xlsx-table'
import accounting from 'accounting'
import QnInput from '@/components/QnInput'
import QnImage from '@/components/QnImage'
import echarts from 'echarts'

accounting.settings.currency.symbol = '￥'
accounting.settings.currency.format = {
  pos: '%s%v', // for positive values, eg. "￥ 1.00" (required)
  neg: '%s-%v', // for negative values, eg. "￥ (1.00)" [optional]
  zero: '%s 0.00' // for zero values, eg. "￥  0.00" [optional]
}

for (const key in accounting) {
  if (typeof accounting[key] === 'function') {
    Vue.filter(key, accounting[key])
  }
}

Vue.prototype.$accounting = accounting

Vue.prototype.$getUser = function () {
    const timeout = 5000
    const interval = 1000
    let timer = null
    return new Promise((resolve, reject) => {
    const startTime = Date.now()
      const fn = () => {
      const usedtime = Math.floor((Date.now() - startTime))
      if (usedtime > timeout) reject(new Error('获取用户信息超时'))
        let user = localStorage.getItem("user_data")
      if (user) {
      try {
        resolve(JSON.parse(user))
      } catch(e) {
        reject(new Error('用户信息解析出错'))
      }
      } else {
        if (timer) clearTimeout(timer)
        timer = setTimeout(fn, interval)
      }
    }
      fn()
    })
}

Vue.prototype.$getUserAll = function () {
  const timeout = 5000
  const interval = 1000
  let timer = null
  return new Promise((resolve, reject) => {
  const startTime = Date.now()
    const fn = () => {
    const usedtime = Math.floor((Date.now() - startTime))
    if (usedtime > timeout) reject(new Error('获取权限超时'))
      let user = localStorage.getItem("user_all")
    if (user) {
    try {
      resolve(user)
    } catch(e) {
      reject(new Error('权限解析出错'))
    }
    } else {
      if (timer) clearTimeout(timer)
      timer = setTimeout(fn, interval)
    }
  }
    fn()
  })
}

Vue.component('qn-input', QnInput)
Vue.component('qn-image', QnImage)

// 全局filter注册
const filterNames = Object.keys(filters)
filterNames.forEach(name => {
  Vue.filter(name, filters[name])
})
Vue.use(directive)
Vue.use(ElementUI, {  })
Vue.use(vueXlsxTable)
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
import env from './env.js' //just run
Vue.use(common)
Vue.prototype.$bus = new Vue();
window.eventBus = new Vue();


new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js